import {IIframeLoaderConfig, ISkinConfig} from "../common";

export type TokenMap = Record<string, string| number>

const replaceTokens = (input: string, tokenMap: TokenMap): string => {
    // Create a regex pattern from the keys of the tokenMap
    const pattern = new RegExp(Object.keys(tokenMap).join('|'), 'g');

    // Replace tokens in the input string using the regex
    return input.replace(pattern, (matched) => {
        // Return the replacement value from the tokenMap
        return (tokenMap[matched] || matched).toString();
    });
}

export const createIframeSkinByTokenizer = (selectedSkin: ISkinConfig, tokenMap: TokenMap) => {
    const typedSkinConfig = (selectedSkin.loader as IIframeLoaderConfig)
    if (typedSkinConfig.type !== 'IframeLoader') {
        throw new Error(`iframeSkinUrlTokenizer received skin with loader type "${typedSkinConfig.type}", currently only "IframeLoader" is supported`)
    }

    selectedSkin.loader = {
        ...selectedSkin.loader
    }

    selectedSkin.loader.url = replaceTokens(selectedSkin.loader.url, tokenMap);

    return selectedSkin;
}

export const changeSkinUrlByTokenizer = (tokenMap: TokenMap) => {
    return async (selectedSkin: ISkinConfig) => {
        return createIframeSkinByTokenizer(selectedSkin, tokenMap);
    }
}